import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Brain, Castle, Crown, Skull } from "lucide-react";
import { XpBar } from "@/pages/plyx/PlyxBrainClash";

const GameCard = ({ to, testId, icon, title, tagline, accent, badge, soon }) => {
  const inner = (
    <div className={`rounded-2xl p-5 border transition-colors ${soon ? "bg-white/[0.03] border-white/10 opacity-70" : `border-white/10 hover:border-white/30 ${accent}`}`}>
      <div className="flex items-start justify-between">
        {icon}
        <span className={`text-[10px] font-extrabold px-2 py-0.5 rounded-full ${soon ? "bg-white/10 text-white/50" : "bg-black/30 text-white"}`}>{badge}</span>
      </div>
      <div className="font-extrabold text-lg mt-2">{title}</div>
      <div className="text-xs opacity-80 mt-1 leading-relaxed">{tagline}</div>
    </div>
  );
  return soon ? (
    <div data-testid={testId}>{inner}</div>
  ) : (
    <Link to={to} data-testid={testId} className="block">{inner}</Link>
  );
};

export default function PlyxGamesHub() {
  return (
    <div className="min-h-screen millions-stage text-white pb-24" data-testid="plyx-games-hub">
      <div className="max-w-xl mx-auto px-4 pt-6">
        <Link to="/plyx/feed" className="flex items-center gap-1 text-white/60 text-sm mb-4" data-testid="games-back-feed">
          <ArrowLeft className="w-4 h-4" /> Back to feed
        </Link>
        <h1 className="text-3xl font-extrabold">Plyx Games 🎮</h1>
        <p className="text-sm text-white/60 mt-1 mb-5">One profile, one wallet, one XP level — every game feeds the same account.</p>

        <XpBar />

        <div className="grid gap-3">
          <GameCard
            to="/plyx/millions" testId="games-card-millions"
            icon={<Crown className="w-7 h-7 text-[#FFB42D]" />} badge="LIVE"
            accent="bg-gradient-to-br from-[#FFB42D]/20 to-[#FF2D7A]/10"
            title="Plyx Millions"
            tagline="8 Millionaire-standard questions. Solo climbs, 1v1 duels, team battles, Nations League and the nightly Golden Hour." />
          <GameCard
            to="/plyx/clash" testId="games-card-clash"
            icon={<Brain className="w-7 h-7 text-[#00E0C7]" />} badge="NEW"
            accent="bg-gradient-to-br from-[#00E0C7]/20 to-[#1a7bff]/10"
            title="Plyx Brain Clash"
            tagline="Live quiz rooms — up to 10 friends answer the same questions at the same time. Speed bonuses, combo streaks, 3 lives." />
          <GameCard
            to="/plyx/survivor" testId="games-card-survivor"
            icon={<Skull className="w-7 h-7 text-[#FF2D7A]" />} badge="NEW"
            accent="bg-gradient-to-br from-[#FF2D7A]/20 to-[#FFB42D]/10"
            title="Plyx Survivor"
            tagline="Up to 100 players enter, one champion remains. Answer wrong and you're OUT — spectators predict the winner for bonus XP." />
          <GameCard
            to="/plyx/kingdoms" testId="games-card-kingdoms"
            icon={<Castle className="w-7 h-7 text-[#a78bfa]" />} badge="NEW"
            accent="bg-gradient-to-br from-[#a78bfa]/20 to-[#FF2D7A]/10"
            title="Plyx Kingdoms"
            tagline="Build your kingdom with gold that grows from your cross-game XP, raid rivals, and climb the global throne." />
        </div>
      </div>
    </div>
  );
}
